// // ChatBot.js
// import React, { useEffect, useRef, useState } from 'react'
// import env from '../../config/configuration'
// import './chat.css'

// const ChatBot = () => {
//   const [messages, setMessages] = useState([])
//   const [inputMessage, setInputMessage] = useState('')
//   const [isLoading, setIsLoading] = useState(false)
//   const messagesEndRef = useRef(null)

//   // Replace with your actual OpenAI API key (use environment variables in production)
//   const OPENAI_API_KEY = env.OPEN_API

//   const scrollToBottom = () => {
//     messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
//   }

//   useEffect(() => {
//     scrollToBottom()
//   }, [messages])

//   const handleSendMessage = async (e) => {
//     e.preventDefault()

//     if (inputMessage.trim() === '') return

//     // Add user message to chat
//     const userMessage = {
//       role: 'user',
//       content: inputMessage,
//     }

//     setMessages((prevMessages) => [...prevMessages, userMessage])
//     setInputMessage('')
//     setIsLoading(true)

//     try {
//       const response = await fetch(
//         'https://api.openai.com/v1/chat/completions',
//         {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${OPENAI_API_KEY}`,
//           },
//           body: JSON.stringify({
//             model: 'gpt-4',
//             messages: [
//               { role: 'system', content: 'You are a helpful assistant.' },
//               ...messages,
//               userMessage,
//             ],
//             temperature: 0.7,
//             max_tokens: 500,
//           }),
//         }
//       )

//       // Add AI response to chat
//       const aiMessage = {
//         role: 'assistant',
//         content: response.data.choices[0].message.content,
//       }

//       setMessages((prevMessages) => [...prevMessages, aiMessage])
//     } catch (error) {
//       console.error('Error calling OpenAI API:', error)
//       // Add error message to chat
//       setMessages((prevMessages) => [
//         ...prevMessages,
//         {
//           role: 'assistant',
//           content: 'Sorry, I encountered an error. Please try again.',
//         },
//       ])
//     } finally {
//       setIsLoading(false)
//     }
//   }

//   return (
//     <div className='chatbot-container'>
//       <div className='chatbot-header'>
//         <h2>AI Chatbotttt</h2>
//       </div>

//       <div className='chatbot-messages'>
//         {messages.length === 0 ? (
//           <div className='empty-message'>Send a message to start chatting!</div>
//         ) : (
//           messages.map((message, index) => (
//             <div
//               key={index}
//               className={`message ${
//                 message.role === 'user' ? 'user-message' : 'ai-message'
//               }`}
//             >
//               {message.content}
//             </div>
//           ))
//         )}
//         {isLoading && (
//           <div className='loading-indicator'>
//             <span>AI is thinking</span>
//             <span className='loading-dots'>...</span>
//           </div>
//         )}
//         <div ref={messagesEndRef} />
//       </div>

//       <form className='chatbot-input' onSubmit={handleSendMessage}>
//         <input
//           type='text'
//           value={inputMessage}
//           onChange={(e) => setInputMessage(e.target.value)}
//           placeholder='Type a message...'
//           disabled={isLoading}
//         />
//         <button type='submit' disabled={isLoading}>
//           {isLoading ? 'Sending...' : 'Send'}
//         </button>
//       </form>
//     </div>
//   )
// }

// export default ChatBot

import React, { useEffect, useRef, useState } from 'react';
import env from '../../config/configuration';
import Layout from '../Layout';

// Sample avatars (replace with your own images)
const userAvatar = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAJQAmAMBIgACEQEDEQH/xAAcAAAABwEBAAAAAAAAAAAAAAAAAgMEBQYHAQj/xAA6EAACAQMCBAQEAwYFBQAAAAABAgMABBEFIQYSMUETUWFxByIygRSRoSNCscHh8CRSYnLRFSUzgrL/xAAZAQEAAwEBAAAAAAAAAAAAAAAAAQIEAwX/xAAhEQACAgICAwADAAAAAAAAAAAAAQIRAyESMQQTIkFRYf/aAAwDAQACEQMRAD8AtSRcgwg+UDA37dqUXOQMdRmuBemeo8qV5Dv5HuK5FwuOuKMEydxtRgAwxuKcKoG5xj1qQJJEe2wpZYwCcCmWs6vp2i2vj6ndJDHnAydz7DvWXcRfErVtQc2+gqbKz6CVwOdx55Ow/jUpA03V9Z07SlAurtFk3Ii+pz7Ab1Vrz4l2SRsILS5ZwcKWTlBPbr2rJ21CX8V+KvY0uXO7sWJZvdh/OhDDbTJ4ySuSCG8NjzqB643HvShZoQ+KV5FLz3WjIIiQdpf7Bq3aFx5w/qrLELwW8zbCO4HISfIZ2NY7pksiv4TCSKJjyFhJ8uf8rL+dN762jS1/ExxRxyoxSWIMc9djg/bv0pQPShUMmUIIPQjvTWRTzKPWsm+HHHsunldP1q4aS02ELtuydBymtehkiuVSWFg6McgioYCslDk2pcp5iiEdsUA3CgAjcg10A5yRnp1o5XfcbV3l8ulQBMbHHUetdVcdK6U710A7+XpQAA7UKORvkdfKhQDBR02NKcqndsjG9d8MDpRvDBIBBoDpj59geveuaheWul6dPe30gjt4VLux9PKl0BClsewrKvjfqc0f/TdMjdhG8bTSjP1bgL+WDUpAovFWvTcS6tLeztyRrtbwudo08v8Ace9RBikVv3lZBsMdKRWQhuYgE7Yz6UYGSRubJOTuRVyoZWcSDxHKnP1HfFWIWbQQido2ivbdQytkFZF79PQ+/pvUVb6VJdws0DKZV3KM2Cw+9TCOkempBMxS7j+jnyrY/mOu4/rQskBpE/EsgQK0qh7Zm/fxkge/T75qP1C4DtMmSviAA52C4OQP6+9N/HKgwSKTFnKfNnlPoam7DSrm+KskJlumXlwf/on2qkpKO2WUXLSKwHZQ4UDy6ZrWvhVxTLPcjS5wHjYlw4zgHYY39Pt1rL9Vs57K58G6jMbqOmNvtT3hLUzpuswSJIYVZgrMd+48yMdOtT2rK1Tpnp0r50mV3pxEwmgSVCCrqCK4yVAGbLvRejYx605aOucnSoA0diCM4A7+9HiKtsDvSzxA9q54Q7YB86A5yiuUoEbPVce1CgGA277eZpVXUAYP5UTw4+dcRjf0o4iQHKqFPpUg6JPmB7evesZ+N0Uh4isZcgpLbBUwe4bf+NbT+Hi2PIDjJAPnWafHPTg+l6ZqKLvBM0TYG2HAP8V/WpQZjfKMn0NWHh+0VlkkEgWPGCSf4jtUFDvKCF5t8kVOWVzLNJ4MINshOCkfQ/8ANRKVImEbY4uDKLlnQDPQKD09u4qc0ThLU+I08a5l5YebKh8ZJ88ipfQuG0cxvcEcvXB71e7IJboEhVVUHotZZ570jZHx63Ir+l/CyyiTmu2MjdetWq00Ky02MpAn0jAyO1S9vODEMntSUsinIzWebbR1iqZl/wATdCWeKG8SLLo/KcdCKyk2/JclWXK56Z2r0dq1utzYzxMM5U496xjUtPVLl/C5UBP3B/v+FaPGya4nDycf5Nv4HvHv+GbGd33MQBHlip07dzVT+EziTg6HHRJGGPvVvYA1qMgjmis6570qVArnKOm2PagEiwGcjauqwI2pTlFFMY7dfOoYAaFGK52oUBHL0Htmjdx6nFBRk5HTyo/bb7VIFUHyjNVH4paZJf8ABV6sa5a3/wAR9k3P6Zq3x9BSzLFOjQTKCkgKkHoRSweTNMZfxQ5hjIqWsWEV6h8jv+dOeMeHW4d4zudOVCsBbxbc42MZGRj2OR9qj0uYrW7JkBc9lXrmqZFfR2xNLs2Lh+VJolAxnHepl/2QxWYaHxWloyLNbXMQOxLJtV50zXbTVQscMilycDBrA4OPZ6KnGXRYrKTmUEkYBxucUw1TiXR7Fisl/EZAcciHmOfYVB8ZRXFtYHxWnWHusbFeb3I3xVR0e+udNubf8Dw/C34jm5JBGZGyOgIG4z6n1q8IqWjnN8dmh2utwXT8gWcZ6eJCygj3xVJ+IOiR25XUbUFBI4WVR06bGr/ptxqVzdyW+oWcahMcssRwjeoB3FNuNdMF1o93Ao3MeQfUb1zXxPRZrnGmG+HE7abw5aw36mITylkZnGPm+nAz7Vd5AAD5gVTtPli1bhGC3WPwZvwyGFiAeYhQQR9x+lXC0zLZwvIN3jBI9SBWzFkcm0zHmxRjFNHStFKnI22NKkeVcxt6Cu5mEwp+1DGKPjDGisMigOgD8xQrsStg8xJ8tsUKgEWopQJSadaXWpAZVpzCPL7Ugq04iXINAZJ8bSw1rQy0MYjKOBP+8Sdivt0rNllW0u2kgVGuGfq4+mtf+N2kPd6BBq0CkyadKGcDujbZ+x5T7ZrI47Jbu8PLKAXwyqe4Nc56Vs7Y99Fp0S0ur83A1u7Sazdf2bhvmB7ALjHr57epqC4ckOlcZLDbylohIVBPfyq5abpJtNPJjQbr9Xes/TmXiFAhPMJgSa4RnzTRrcODiz0TfWi6lYBJVBWRMHPtVcs+FU02bxBPPtnGH/pVj0yZp9LgaIcxCCuXk0oUFkx6Vn6Ose6FNNiUj9lFygdSTkmhq8IaLcem1G0u9i5cHb3rmrXEfhOwPRTRpUV3yIjhe3W4hjCHlWxeSERg9yc59sHarlCgWFExsFAqkfDe7W41TWYcEFWSQAnbcYJ/Sr7y46dK2YMdXIx+Rk5Pj+hIDfpjFAjfFH5BnfvQK5O/nWgzCZXYelcCgkk9TSuK4F3A86hkgUYFCjgUKAgFNOE3ApqhpzGQakDlBTiIfLSCjcYBB88U4jOBUARurK31G2uLK9jElvPGY5EPdTsf415x1nTZNA16fT5GaRrN+QP/AJo8/KT9uvtXphVIORjesQ+N+nvYcQWmqp9NzHyP5EiokrReEqY9i1SMaIcHfkrMTdpbX09wfmcP8gA2Yf3mnh1bFlyjLZ2xUTMGmlLq/hRByC52PrWfFjq7NeXKnVdms8P8cxf9Ib8S72ELYRXHKX5u+Bv+tSlpxvosCck2oXFy53VpwM+2wAqlaDbW89h4Daab+IkESHICY6e9WKx4WeWzC+Bbxc+FClOdlA/QVVqJoUJtWyfseItJ1OQLbSeHMTgDOxppxXrUdnYuquPGOYx33qv6lwPNw/e2Wo292ZLczKZ0Kgch65GO3UVWOJr/AMXU2CtzRqSq9wxJyf41T1py+Tm5tL6Lz8FpXuuIdVlZs8tuob35j/StgxWY/AnTHi0a+1WdAGu5uWLHeNR1+5zWoVuiqR50nbsLtXMUfFDFWorYny71wIecHtSuD5Cub5qKATFClMUKUSVmPancWd+nWmqfURinkK5xUAWQNjsacICe9JIBsPOnKDagDqKguOuGouKOHp7EhROFLQOf3X7VYFGMUlfXtpp1rJdX9xFbwRrlpJXCgAVZA8f31vcadezWV0GjmiYgqw3GPSnojtpIoQiH5epJyevWrX8U+LNA4svkbRrGT8RGCrX0h5BIu2AE6n3OKpNhJyXHLIQiNsSQSKrKLa0WhKnsvGh6lLaQOltaPMmAR85ANaPwedRu0M1+kcMZ3WNfL1rMNM1+1sRycofb8t8VKR8fvaQrHEQMEDmJ2Uf3isbhJvo9D2rj2Xb4manHZ6S8AkAlcEKPI4rIuG9Kk4h1OG1eRo1Clp2K9ADjAPnS+o6lf8U3wiiSSYzOVRBnYk4P29a1PgvhUaNp6eMM3uSZJd8nP8v+K6axx/pn3kl/C58PJb2MS2cHLHEqKI0GwwNsCpvI7ZPnt0qt3MAeMDGMHOR50lM2qCLktb+SFgPlcor49ww3FUxZ+PzIZMHL6iWrbtQrN9H+JMkd61nxBbx4QspubVGwSuxJXf8AQ1ftN1Gy1SAT6ddRXEfco2cehHat7i+zGOgKBFGoVAC/au12hUArEfXHvT2JfPI2xTSOPOObp3pLVuItG4fgD6xfxW2fpRiWdvZRkn8qqWJpFG2/Su3d3a6davd31xFb28Yy8kjhVUVlOu/GWBEePh7T3llI+Sa6+VPflG5/MVk/EvEWs8SXQk1i8kuChPJH0SP/AGqNhV1BkNmu8UfGyytme34btDdumxu58rH/AOq9W++Kx3iHibV+I7r8Rq9/NcYPyRk4RP8Aao2FRso5UCDOc0UpuFFX4lTkBwxNPFj8YEcxXJ2IpmAQ+R0qX063eYoUGVPeuOT52dcavQ3ltJeZiflUksnKenpU7wnw7Bql2EvbibHdVXKkeWam7Xh03NuWfY42xU5wzazaf+y5AwB6nrWd52aY4EnsuHDXDWl6HD/2+25WY5ZzuT/easUS4GKi7a7/AGaZ/KpW3PMBWdttnauKFcogHP0Y4zUbxPrEGhaZ4smGnfIjjz38z6Cltdv7LT9Nke+fCsuFVfqc+lZNreq3Gt334i5I5QAFVRsAOgHp3+9a/F8b2O5dGPPm46XZHSNNP4k8h/aysSDjdQTk/nS2nXlzY3CXdjcS28vXKvjPuO/60fkLyHfFNWjwW228/KvZ4qqPPbd2aLovxLljCrrFt4sfQzRbMPdehrQNI1fT9Wg8XT7hJFHVQcMvuOorz3DKJH5GxinUE01mySWssscqNlHjOCK5TwJ9FlN/k9E0KyfSfiNqtsqpfQxXiD6tuSTHv0P5UK4PDM6c0SXG3GNtwtZFUCTalMuYLcnYf62/0j9cYrDbt59Qvpbq7ne5vJjzSysTnJ8vTGwHbtQ1fUbrWL6a+vJC80z8xOOnoPIDyo8AKxBY/rYA832G9dMWNJFZzYjNAsIEcQDSHq3lSMNryozEZI/e86fvhI+VTl3OKWvI0t7Jic7A9q68Uc+TKzyNLckKNhR0iLSuOuOtTOg6f4sLXEhxzb713T7ZGvbhSAds1zWMu5ENBblyRjOKm9JeXTJPEjVZEY5aNweVj/I1y3jVJXAAHbpToxEIN9u9W9UWqY9kk7RddC17S5WVZZRbHG6TDAB9G6EVb7eGzmHiQTwPnujqR+hrHY9zllzj8xTkIvL1PL5bbVll4EL06NMfNmlTRqs1zaWRzPdwRgH96QZpC+46tLaDwtNjNxKRjnYYUew6mswCRqc/N674p7bybcqqq+oHWph4EE7bsrPy5yVJUSOoahc6hcGe8lZ5D0B7DyHkKYAlsMSMDtXJ35f3xvRuide3n1rdFKKpGVtvsXtBzc7EAZOxxRAoLsmR3pxp4Ph7jsTTMfLeco3zg+1SQNLofhLhNvqqTi5Zo8iialZ+MVxnIGR6VH2d09lOLe4H1fSx6GpsEiGKnB5iPPyoUa8CmEFQfl7L3PYUKAosP0A/6qlrdQLdSBuyD+dChVIdBiEY57+EN05eb70XXJGaOJSdmcA/ehQqZdEx7JlUWKxRYxgctRuj73N0x6ha7Qp+iAsH/lB8yc1J3CgcoA7UKFEBsPrPp0pxL8qrjqcZJrtCpYCseWLmAGfal9NYtKcgbDYUKFAHuz/io07ZzQuOnlQoUA+sTyooHcUz1HMN6jITknH60KFATMoD26swGdqhdfiUaaZR9cTBkPlQoUA508me2tWk3LMhJ9aFChUMk//Z';
const aiAvatar = 'data:image/jpeg;base64,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';

const ChatBot = () => {
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef(null);

  // Replace with your actual OpenAI API key (use environment variables in production)
  const OPENAI_API_KEY = env.OPEN_API;

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    console.log('Chat Container Scrolled');
    scrollToBottom();
  }, [messages]);

  const handleSendMessage = async (e) => {
    e.preventDefault();

    if (inputMessage.trim() === '') return;

    // Add user message to chat
    const userMessage = {
      role: 'user',
      content: inputMessage,
    };

    setMessages((prevMessages) => [...prevMessages, userMessage]);
    setInputMessage('');
    setIsLoading(true);

    try {
      const response = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${OPENAI_API_KEY}`,
        },
        body: JSON.stringify({
          model: 'gpt-4',
          messages: [
            { role: 'system', content: 'You are a helpful assistant.' },
            ...messages,
            userMessage,
          ],
          temperature: 0.7,
          max_tokens: 500,
        }),
      });

      const data = await response.json(); // Parse the response as JSON

      if (!response.ok) {
        throw new Error(data.error?.message || 'Failed to fetch AI response');
      }

      // Add AI response to chat
      const aiMessage = {
        role: 'assistant',
        content: data.choices[0].message.content,
      };

      setMessages((prevMessages) => [...prevMessages, aiMessage]);
    } catch (error) {
      console.error('Error calling OpenAI API:', error);
      // Add error message to chat
      setMessages((prevMessages) => [
        ...prevMessages,
        {
          role: 'assistant',
          content: 'Sorry, I encountered an error. Please try again.',
        },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Layout>
      <div className="flex flex-col flex-1 p-4 pt-0">
        <div className="text-white font-bold text-2xl">SMS</div>
        {/* Centered Chat Section - Adjusted Height */}
        <div className="flex flex-col w-full max-w-md mx-auto" style={{ height: 'calc(100vh - 4rem - 2rem)', maxHeight: '500px' }}>
          {/* Chat Area */}
          <div className="flex-1 overflow-y-auto p-5">
            {messages.length === 0 ? (
              <div className="text-center text-gray-400 mt-10">
                Send a message to start chatting!
              </div>
            ) : (
              messages.map((message, index) => (
                <div
                  key={index}
                  className={`flex mb-4 ${
                    message.role === 'user' ? 'justify-end' : 'justify-start'
                  }`}
                >
                  {/* AI Message */}
                  {message.role === 'assistant' && (
                    <>
                      <img
                        src={aiAvatar}
                        alt="AI Avatar"
                        className="w-10 h-10 rounded-full mr-3"
                      />
                      <div className="max-w-[70%] bg-[#E6F0FA] text-black p-3 rounded-2xl shadow-md">
                        {message.content}
                      </div>
                    </>
                  )}

                  {/* User Message */}
                  {message.role === 'user' && (
                    <>
                      <div className="max-w-[70%] bg-white text-black p-3 rounded-2xl shadow-md">
                        {message.content}
                      </div>
                      <img
                        src={userAvatar}
                        alt="User Avatar"
                        className="w-10 h-10 rounded-full ml-3"
                      />
                    </>
                  )}
                </div>
              ))
            )}
            {isLoading && (
              <div className="flex justify-start mb-4">
                <img
                  src={aiAvatar}
                  alt="AI Avatar"
                  className="w-10 h-10 rounded-full mr-3"
                />
                <div className="max-w-[70%] bg-[#E6F0FA] text-black p-3 rounded-2xl shadow-md">
                  <span>AI is thinking</span>
                  <span className="animate-pulse">...</span>
                </div>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          {/* Input Area - Centered within the chat section */}
          <form className="p-5" onSubmit={handleSendMessage}>
            <div className="flex items-center bg-white border border-gray-300 rounded-3xl p-4 w-full h-16">
              <svg
                className="w-6 h-6 text-gray-600 mr-3"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  stroke

Linejoin="round"
                  strokeWidth="2"
                  d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828L17 9.828a4 4 0 00-5.656-5.656L4.757 10.757a6 6 0 108.486 8.486L19.828 12"
                />
              </svg>
              <input
                type="text"
                placeholder="Type your message here..."
                className="flex-1 bg-transparent outline-none text-black placeholder-gray-400 text-lg"
                value={inputMessage}
                onChange={(e) => setInputMessage(e.target.value)}
                disabled={isLoading}
              />
            </div>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default ChatBot;